import {ChangeDetectionStrategy, Component, inject, signal} from '@angular/core';
import {MatFormField, MatLabel} from "@angular/material/form-field";
import {MatInput} from "@angular/material/input";
import {FormsModule} from "@angular/forms";
import {MatButton} from "@angular/material/button";
import {finalize} from "rxjs/operators";
import {DomainService} from "../../services/domain.service";
import {BusyService} from "../../services/busy.service";
import {AlertService} from "../../services/alert.service";
import {UtilService} from "../../services/util.service";

@Component({
    selector: 'app-domain-check',
    imports: [
        MatFormField,
        MatLabel,
        MatInput,
        FormsModule,
        MatButton
    ],
    templateUrl: './domain-check.component.html',
    styleUrl: './domain-check.component.scss',
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class DomainCheckComponent {

    private domainService = inject(DomainService);
    private busyService = inject(BusyService);
    private alertService = inject(AlertService);
    private utilService = inject(UtilService);

    domainName = signal<string>('');

    checkAvailability() {
        const name = this.domainName().trim();
        if (!name)
            return;
        this.busyService.showBusy();
        this.domainService.isAvailable(name).pipe(
            finalize(() => { this.busyService.showNotBusy() })
        ).subscribe({
            next: (available) => {
                const message = available
                    ? `Domain "${name}" is available.`
                    : `Domain "${name}" is not available.`;
                this.alertService.info(message);
            },
            error: this.utilService.getErrorHandler(`Error checking availability of "${name}"`)
        });
    }
}
